module.exports = __webpack_public_path__ + "public/img/idMachine.d4d395cb.png";